import classnames from 'classnames';

import styles from './styles.module.scss';

export const BrokenHeart = ({ mounted }: { mounted: boolean }) => {
  return (
    <>
      <img
        src="/public/BrokenHeartLeft.svg"
        className={classnames(styles.left, mounted && styles.mounted)}
        data-cy="brokenHeart"
      />
      <img
        src="/public/BrokenHeartRight.svg"
        className={classnames(styles.right, mounted && styles.mounted)}
        data-cy="brokenHeart"
      />
    </>
  );
};
